import { CEAssignedProjectAttributesBase } from './ce-assigned-project-attributes-base'


export class CEAssignedProjectAttributes extends CEAssignedProjectAttributesBase {

}